<template>
  <div class="container print3d-root">
    <section class="hero">
      <h1 class="title">Impresión 3D bajo demanda</h1>
      <p class="text hero-text">
        Convierte tus ideas en objetos reales. Te ayudamos desde el archivo 3D
        listo para imprimir hasta el modelado completo de piezas a medida.
      </p>
      <div class="hero-actions">
        <WhatsAppButton
          variant="inline"
          label="Cotiza por WhatsApp"
          message="Hola, quiero cotizar una impresión 3D."
        />

        <!-- Atajo a la vitrina: quien llega a comprar algo ya hecho no tiene
             por qué recorrer los tres flujos de cotización para encontrarla. -->
        <button type="button" class="season-btn" @click="scrollToSeason">
          Productos de temporada
          <span class="season-arrow" aria-hidden="true">↓</span>
        </button>
      </div>
    </section>

    <FlowSelector v-model="flow" class="section-block" />

    <div ref="flowTarget" tabindex="-1" class="flow-target">
      <QuoteSection v-if="flow === 'print'" class="section-block" />
      <ModelingRequestSection v-else-if="flow === 'modeling'" class="section-block" />
      <PuzzleCustomizer v-else-if="flow === 'custom'" class="section-block" />
    </div>

    <!-- El catálogo va siempre debajo de los módulos desplegables. Al cerrar
         el módulo activo sube a la vista, que es el estado de recarga.
         El `id` también sirve de ancla: /print3d#productos-temporada. -->
    <CarouselSection
      ref="catalogSection"
      id="productos-temporada"
      class="section-block season-target"
    />
  </div>
</template>

<script>
import CarouselSection from './Print3D/CarouselSection.vue';
import FlowSelector from './Print3D/FlowSelector.vue';
import QuoteSection from './Print3D/QuoteSection.vue';
import ModelingRequestSection from './Print3D/ModelingRequestSection.vue';
import PuzzleCustomizer from './Print3D/PuzzleCustomizer.vue';
import WhatsAppButton from './WhatsAppButton.vue';

export default {
  name: 'Print3DPage',
  components: {
    CarouselSection,
    FlowSelector,
    QuoteSection,
    ModelingRequestSection,
    PuzzleCustomizer,
    WhatsAppButton,
  },
  data() {
    return {
      // null hasta que el visitante elige: solo se revela el flujo elegido.
      flow: null,
    };
  },
  methods: {
    // Mismo gesto que el cierre de un flujo: deja la sección arriba, ya
    // descontada la cabecera fija (scroll-margin-top de .season-target).
    scrollToSeason() {
      this.$refs.catalogSection?.$el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
  },
  watch: {
    flow(value) {
      this.$nextTick(() => {
        // Al cerrar, la vista vuelve al catálogo: el estado de recarga.
        if (!value) {
          this.$refs.catalogSection?.$el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        // Al elegir, lleva la vista y el foco al formulario correspondiente.
        const target = this.$refs.flowTarget;
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        target.focus({ preventScroll: true });
      });
    },
  },
};
</script>

<style scoped>
.print3d-root {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
  padding-bottom: var(--space-xl);
}

.hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 0;
}

.hero .title {
  margin-bottom: 0.5rem;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}

.season-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.4rem;
  border: 1px solid var(--color-action);
  border-radius: 9999px;
  background: var(--color-white);
  color: var(--color-action);
  font-family: var(--font-body);
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.season-btn:hover {
  background: var(--color-action);
  color: var(--color-white);
  transform: translateY(-2px);
}

.season-btn:focus-visible {
  outline: 2px solid var(--color-action-hover);
  outline-offset: 3px;
}

.season-arrow {
  font-size: 1.1rem;
  line-height: 1;
}

/* El destino del botón queda por debajo de la cabecera fija. */
.season-target {
  scroll-margin-top: calc(var(--header-offset) + var(--space-sm));
}

.hero-text {
  max-width: 720px;
  margin: 0 auto var(--space-md) auto;
}

.section-block {
  width: 100%;
}

/* El contenedor del flujo recibe el foco al elegir opción: sin contorno
   permanente, pero visible para navegación por teclado. */
.flow-target {
  scroll-margin-top: calc(var(--header-offset) + var(--space-sm));
}

.flow-target:focus {
  outline: none;
}

.flow-target:focus-visible {
  outline: 3px solid var(--color-action);
  outline-offset: 4px;
  border-radius: 12px;
}

@media (max-width: 800px) {
  .hero {
    text-align: left;
    align-items: flex-start;
  }
}
</style>
